"use client";
import { jsxs as N, Fragment as z, jsx as r } from "react/jsx-runtime";
import c from "clsx";
import A from "next/image";
import D from "next/link";
import { composeRef as F } from "rc-util/lib/ref";
import { forwardRef as V, createRef as q, isValidElement as G } from "react";
import { s as t } from "../../Button.module-C3Ja-wjg.js";
const H = (b, y) => {
  const {
    title: d,
    text: n,
    iconLeft: o,
    iconRight: a,
    size: k = "normal",
    color: w = "orange",
    wide: R,
    centerText: L,
    loading: s,
    disabled: m,
    error: B,
    className: I,
    href: f,
    authType: T,
    onClick: l,
    children: j,
    nativeLink: K,
    scroll: C = !0,
    ..._
  } = b, h = (e) => {
    var v;
    if (s || m) {
      e.preventDefault();
      return;
    }
    const i = e.currentTarget.getAttribute("data-event");
    i && ((v = window == null ? void 0 : window.dataLayer) == null || v.push({
      event: i
    })), l == null || l(e);
  }, p = (e, i) => G(e) ? /* @__PURE__ */ r("div", { className: c(t.icon, i), children: e }) : typeof e == "string" ? /* @__PURE__ */ r(
    "div",
    {
      className: c(
        "material-icons",
        t.icon,
        { [t._loading]: s },
        i
      ),
      "data-icon": s ? "progress_activity" : e
    }
  ) : /* @__PURE__ */ r(
    A,
    {
      className: c(t.icon, t.image, i),
      src: e,
      height: 24,
      width: 24,
      alt: "icon"
    }
  ), u = /* @__PURE__ */ N(z, { children: [
    o && p(o, t.icon__left),
    n && /* @__PURE__ */ N("span", { className: t.text_block, children: [
      d && /* @__PURE__ */ r("span", { className: t.title, children: d }),
      /* @__PURE__ */ r("span", { className: t.text, children: n })
    ] }),
    j,
    a && p(a, t.icon__right)
  ] }), g = c(
    t.button,
    t[w],
    t[k],
    {
      [t.icon__left]: o && n,
      [t.icon__right]: a && n,
      [t.icon__center]: o && !n || a && !n,
      [t._wide]: R,
      [t._center_text]: L,
      [t._loading]: s,
      [t._disabled]: m,
      [t._error]: B,
      [t.auth_type]: T
    },
    I
  ), E = q(), x = F(y, E);
  return f ? /* @__PURE__ */ r(
    D,
    {
      ..._,
      ref: x,
      href: f,
      onClick: h,
      className: g,
      scroll: C,
      children: u
    }
  ) : /* @__PURE__ */ r(
    "button",
    {
      ..._,
      ref: x,
      onClick: h,
      className: g,
      children: u
    }
  );
}, J = V(H);
J.displayName = "Button";
export {
  J as Button
};
